"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'photo',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      statusObj: {
        0: '未审核',
        1: '审核中',
        2: '审核通过',
        3: '审核不通过'
      },
      list: [],
      listLoading: true,
      listQuery: {
        position_id: '',
        type: 1,
        start: 1,
        total: 10,
        page_num: 1
      }
    };
  },
  mounted: function mounted() {
    this.listQuery.position_id = parseInt(this.$route.query.pid) || 1;
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
          start: this.listQuery.start - 1
        }),
        url = 'agentapi/ad_list';
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 设置是否显示
     */
    setShow: function setShow(row) {
      var _this2 = this;
      var is_show = row.is_show == 1 ? 0 : 1;

      // 【操作埋点】2026-05-25 pc_ad_create_1 切换广告显示状态
      this.$post('agentapi/ad/is_show_switch', {
        id: row.id,
        agree: is_show
      }, {
        operation_option: is_show == 1 ? '显示广告' : '隐藏广告',
        content: "".concat(is_show == 1 ? '显示' : '隐藏', "\u5E7F\u544A\u300C").concat(row.ad_name, "\u300D(ID:").concat(row.id, ")"),
        operation_id: 'pc_ad_create_1'
      }).then(function (res) {
        _this2.$message({
          message: '设置成功',
          type: 'success'
        });
        row.is_show = is_show;
      });
    },
    /**
     * 提交审核
     */
    setReview: function setReview(row) {
      var _this3 = this;
      // 【操作埋点】2026-05-25 pc_ad_audit_1 提交广告审核
      this.$post('agentapi/ad/ad_tobe_audited', {
        id: row.id,
        agree: 1
      }, {
        operation_option: '提交广告审核',
        content: "\u63D0\u4EA4\u5E7F\u544A\u300C".concat(row.ad_name, "\u300D(ID:").concat(row.id, ") \u5BA1\u6838\uFF0C\u6295\u653E ").concat(this.parseTime(row.start_date, '{y}-{m}-{d}'), " \u81F3 ").concat(this.parseTime(row.end_date, '{y}-{m}-{d}')),
        operation_id: 'pc_ad_audit_1'
      }).then(function (res) {
        _this3.$message({
          message: '提交成功',
          type: 'success'
        });
        row.review_status = 1;
      });
    }
  }
};